import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const GreigeSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        backgroundColor: colors.greige,
        hover: {
            color: colors.white,
            backgroundColor: colors.black,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default GreigeSolidButton;
